"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkSignalLevel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const ui_react_1 = require("@streem/ui-react");
const analytics_1 = require("@streem/analytics");
const room_session_1 = require("../../../../context/room_session");
const rxjs_1 = require("../../../../hooks/rxjs");
const NetworkSignalLevel = ({ showNetworkQuality, }) => {
    const [networkLevelIcon, setNetworkLevelIcon] = (0, react_1.useState)({
        icon: 'AverageOrAboveSignalIcon',
        iconColor: ui_react_1.Theme.colors.grey30,
    });
    const [networkLevelToolTip, setNetworkLevelToolTip] = (0, react_1.useState)(null);
    const roomSession = (0, room_session_1.useRoomSession)();
    const [remoteNetworkQuality] = (0, rxjs_1.useObservable)(roomSession.media.remoteNetworkQuality);
    (0, react_1.useEffect)(() => {
        if (!showNetworkQuality)
            return;
        const { headerIcon, tooltip } = mapNetworkLevelIconAttributes(remoteNetworkQuality);
        setNetworkLevelIcon(headerIcon);
        setNetworkLevelToolTip(tooltip);
    }, [remoteNetworkQuality, showNetworkQuality]);
    return ((0, jsx_runtime_1.jsx)(NetworkSignalLevelIconContainer, Object.assign({ "data-testid": "network-status-icon" }, { children: (0, jsx_runtime_1.jsx)(NetworkQualityTooltip, Object.assign({ networkLevelTooltip: networkLevelToolTip }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: networkLevelIcon.icon, color: networkLevelIcon.iconColor }) })) })));
};
exports.NetworkSignalLevel = NetworkSignalLevel;
const NetworkQualityTooltip = ({ networkLevelTooltip, children, }) => {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const tooltipId = 'network-status-icon-tooltip';
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        if (!networkLevelTooltip)
            return;
        setShowTooltip(true);
        (0, analytics_1.recordTooltipViewed)(tooltipId);
    }, [networkLevelTooltip]);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        setShowTooltip(false);
    }, []);
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ message: networkLevelTooltip && ((0, jsx_runtime_1.jsxs)(NetworkQualityTooltipContentContainer, Object.assign({ gap: `${networkLevelTooltip.gap}` }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: networkLevelTooltip.tooltipIcon, color: networkLevelTooltip.iconColor, width: networkLevelTooltip.width, height: networkLevelTooltip.height }), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: ui_react_1.Theme.colors.black, size: "small" }, { children: networkLevelTooltip.text }))] }))), showTooltip: showTooltip, distance: 20, offsetValue: 100, placement: "bottom", fallbackPlacements: ['bottom'], maxWidth: "267px", minWidth: "234px", dataTestId: tooltipId }, { children: react_1.default.cloneElement(children, {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
        }) })));
};
const mapNetworkLevelIconAttributes = (level) => {
    if (level === undefined || level === null) {
        return {
            headerIcon: {
                icon: 'AverageOrAboveSignalIcon',
                iconColor: ui_react_1.Theme.colors.grey30,
            },
            tooltip: null,
        };
    }
    if (level >= 3)
        return {
            headerIcon: {
                icon: 'AverageOrAboveSignalIcon',
                iconColor: ui_react_1.Theme.colors.blue50,
            },
            tooltip: Object.assign({ tooltipIcon: 'CheckmarkIcon', iconColor: ui_react_1.Theme.colors.green50, text: `${level}/5 ${level === 5 ? 'Excellent' : level === 4 ? 'Good' : 'Average'} Network Connection` }, checkmarkIconStyles),
        };
    if (level == 2)
        return {
            headerIcon: {
                icon: 'BelowAverageSignalIcon',
                iconColor: ui_react_1.Theme.colors.blue50,
            },
            tooltip: Object.assign({ tooltipIcon: 'AlertIcon', iconColor: ui_react_1.Theme.colors.orange, text: '2/5 Below Average Network Connection' }, alertIconStyles),
        };
    if (level == 1)
        return {
            headerIcon: {
                icon: 'BadSignalIcon',
                iconColor: ui_react_1.Theme.colors.blue50,
            },
            tooltip: Object.assign({ tooltipIcon: 'AlertIcon', iconColor: ui_react_1.Theme.colors.red50, text: '1/5 Bad Network Connection' }, alertIconStyles),
        };
    else
        return {
            headerIcon: {
                icon: 'LostSignalIcon',
                iconColor: ui_react_1.Theme.colors.grey30,
            },
            tooltip: Object.assign({ tooltipIcon: 'AlertIcon', iconColor: ui_react_1.Theme.colors.red50, text: '0/5 No Network Connection' }, alertIconStyles),
        };
};
const alertIconStyles = {
    width: '23px',
    height: '23px',
    gap: '8px',
};
const checkmarkIconStyles = {
    width: '18px',
    height: '16px',
    gap: '15px',
};
const NetworkSignalLevelIconContainer = (0, ui_react_1.styled)(ui_react_1.Flex)(() => ({
    height: '22px',
    width: '24px',
}));
const NetworkQualityTooltipContentContainer = (0, ui_react_1.styled)(ui_react_1.Flex)(({ gap }) => ({
    gap: `${gap}`,
    alignItems: 'center',
    paddingLeft: '7px',
    height: '36px',
}));
//# sourceMappingURL=network_signal_level.js.map